var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline"},[_c('a',{attrs:{"target":"_blank","href":"/dashboard"}},[_c('NEIcon',{attrs:{"label":"Site Dashboard","color":'orange',"img":require('../img/dashboard.svg')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }